import { useMemo } from 'react';
import { useNitroPoolDetails } from '@app/hooks/nitro/useNitroPoolDetails';
import { formatDistanceStrict } from 'date-fns';
import { formatNumber } from '@app/helpers/format';
import { formatUSD } from '@app/helpers/formatUSD';

export type AlgebraPoolNitroDetails = {
  tvl: string;
  apr: string;
  duration: string;
  minLock: string;
  pendingRewards: number;
  id: string;
};

export function useAlgebraPoolNitroDetails(
  nftPoolAddress: string
): AlgebraPoolNitroDetails | null {
  const {
    data: nitroPoolDetails,
    tvlUsd,
    totalApr,
    pendingRewards
  } = useNitroPoolDetails(nftPoolAddress);

  return useMemo(() => {
    if (!nitroPoolDetails) {
      return null;
    }

    const isEnded =
      new Date().getTime() > +nitroPoolDetails.nitroPool.endTime * 1000;

    if (isEnded) {
      return null;
    }

    return {
      id: nitroPoolDetails.nitroPool.id,
      tvl: formatUSD.format(tvlUsd ? +tvlUsd : 0),
      apr: `${formatNumber(totalApr, 2)}%`,
      duration: nitroPoolDetails
        ? formatDistanceStrict(
            new Date(+nitroPoolDetails.nitroPool.startTime * 1000),
            new Date(+nitroPoolDetails.nitroPool.endTime * 1000)
          )
        : '-',
      pendingRewards,
      minLock:
        nitroPoolDetails?.nitroPool.requiredLockDuration &&
        nitroPoolDetails?.nitroPool.requiredLockDuration !== '0'
          ? Math.ceil(
              +nitroPoolDetails.nitroPool.requiredLockDuration / (60 * 60 * 24)
            ).toString()
          : '-'
    };
  }, [nitroPoolDetails, pendingRewards, totalApr, tvlUsd]);
}
